import _ from 'lodash';
import { bubEvents } from 'javascripts/shared/events/bub_events';

const errorsFromGraphQLRequestError = error => {
  const response = error?.response;

  if (response?.errors) {
    return response?.errors;
  }
  if (response?.error) {
    return [response?.error];
  }

  return [];
};

const promptToReload = query => {
  const message = `
    Whoops! It looks like your session has expired.

    Please reload this page and try again.
  `;

  bubEvents.track('Session expired alert', 'Alert shown', { event_label: 'Request query', event_value: query });

  window.alert(message); // eslint-disable-line no-alert

  if (window.chirpEnv !== 'test') {
    window.location.reload();
  }
};

const graphQLError = (message, code) => {
  return { message, code };
};

export const graphQLUtils = {
  errorsFromGraphQLRequestError,
  friendlyGraphQLErrorMessage(error, fallbackMessage = 'Unknown error') {
    const errors = errorsFromGraphQLRequestError(error);

    if (errors.length > 0) {
      return errors[0].message;
    }
    return fallbackMessage;
  },
  errorFromAxiosError(axiosError) {
    if (!axiosError?.isAxiosError) {
      return graphQLError('Unknown error', 'unknown');
    }

    const message = `Network error: ${axiosError?.response?.statusText} (${axiosError?.response?.status})`;
    return graphQLError(message, 'network_error');
  },
  isUnauthorizedError(errors) {
    if (errors && _.find(errors, error => error?.code === 'unauthorized')) {
      return true;
    }

    return false;
  },
  // Prevent execution more than once per minute
  handleSessionExpired: _.throttle(promptToReload, 60000, { leading: true, trailing: false }),
};
